import { on } from "@ngrx/store";

import { BookEventDialogActions } from "../../job/job-overview/overview-timeline/timeline-book-event/timeline-book-event.actions";

import { BookingScheduleActions } from "./booking-schedule.actions";
import { BookingScheduleState } from "./booking-schedule.state";


export const loadAssetsTriggers = [
  BookEventDialogActions.dialogOpened,
  BookingScheduleActions.toggleRestrictionsButtonClicked,
  BookingScheduleActions.enableSchedulingRestrictionsButtonClicked,
  BookingScheduleActions.overrideSchedulingRestrictionsButtonClicked,
];

export const scheduleReloadTriggers = [
  BookingScheduleActions.datesSet,
  BookingScheduleActions.loadAssetsSuccess,
];

export const scheduleReducers = [
  on(BookingScheduleActions.reloadRequired, (state: BookingScheduleState): BookingScheduleState => ({
    ...state,
    bookingSchedule: {
      ...state.bookingSchedule,
      viewDates: [],
    },
  })),
  on(BookingScheduleActions.showEventsInputSwitched, (state: BookingScheduleState): BookingScheduleState => ({
    ...state,
    bookingSchedule: {
      ...state.bookingSchedule,
      dayMaxEvents: state.bookingSchedule.dayMaxEvents === 0 ? false : 0,
    }
  })),
  on(BookingScheduleActions.datesSet, (state: BookingScheduleState, { title, start, end, view }): BookingScheduleState => {
    return {
      ...state,
      bookingSchedule: {
        ...state.bookingSchedule,
        title,
        start,
        end,
        view,
      }
    }
  }),
  on(BookingScheduleActions.loadAssetsSuccess, (state: BookingScheduleState, { assets }): BookingScheduleState => {
    return {
      ...state,
      bookingSchedule: {
        ...state.bookingSchedule,
        assets,
      },
    }
  }),
  on(BookingScheduleActions.loadEventsSuccess, (state: BookingScheduleState, { events }): BookingScheduleState => {
    return {
      ...state,
      bookingSchedule: {
        ...state.bookingSchedule,
        events,
      },
    }
  }),
  on(BookingScheduleActions.loadAvailabilitySuccess, (state: BookingScheduleState, { availability }): BookingScheduleState => {
    return {
      ...state,
      bookingSchedule: {
        ...state.bookingSchedule,
        availability,
      },
    }
  }),
  on(BookingScheduleActions.loadViewDatesSuccess, (state: BookingScheduleState, { viewDates }): BookingScheduleState => {
    return {
      ...state,
      bookingSchedule: {
        ...state.bookingSchedule,
        viewDates,
      },
    }
  }),
  on(BookingScheduleActions.loadViewDatesError, (state: BookingScheduleState): BookingScheduleState => ({
    ...state,
    bookingSchedule: {
      ...state.bookingSchedule,
      viewDates: [],
    },
  })),
];
